module.exports = {
	"textures": [
		{
			"image": "HotAnimation.png",
			"format": "RGBA8888",
			"size": {
				"w": 2048,
				"h": 2048
			},
			"scale": 1,
			"frames": [
				{
					"filename": "24.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 391
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 155,
						"h": 391
					}
				},
				{
					"filename": "25.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 391
					},
					"frame": {
						"x": 1,
						"y": 394,
						"w": 155,
						"h": 391
					}
				},
				{
					"filename": "26.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 391
					},
					"frame": {
						"x": 1,
						"y": 787,
						"w": 155,
						"h": 391
					}
				},
				{
					"filename": "27.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 391
					},
					"frame": {
						"x": 1,
						"y": 1180,
						"w": 155,
						"h": 391
					}
				},
				{
					"filename": "28.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 391
					},
					"frame": {
						"x": 1,
						"y": 1573,
						"w": 155,
						"h": 391
					}
				},
				{
					"filename": "29.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 391
					},
					"frame": {
						"x": 158,
						"y": 1,
						"w": 155,
						"h": 391
					}
				},
				{
					"filename": "49.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 155,
						"h": 391
					},
					"frame": {
						"x": 158,
						"y": 394,
						"w": 155,
						"h": 391
					}
				},
				{
					"filename": "23.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 1,
						"w": 155,
						"h": 390
					},
					"frame": {
						"x": 158,
						"y": 787,
						"w": 155,
						"h": 390
					}
				},
				{
					"filename": "22.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 8,
						"w": 155,
						"h": 383
					},
					"frame": {
						"x": 158,
						"y": 1179,
						"w": 155,
						"h": 383
					}
				},
				{
					"filename": "21.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 10,
						"w": 155,
						"h": 381
					},
					"frame": {
						"x": 158,
						"y": 1564,
						"w": 155,
						"h": 381
					}
				},
				{
					"filename": "13.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 11,
						"w": 155,
						"h": 380
					},
					"frame": {
						"x": 315,
						"y": 1,
						"w": 155,
						"h": 380
					}
				},
				{
					"filename": "47.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 12,
						"w": 155,
						"h": 379
					},
					"frame": {
						"x": 315,
						"y": 383,
						"w": 155,
						"h": 379
					}
				},
				{
					"filename": "48.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 12,
						"w": 155,
						"h": 379
					},
					"frame": {
						"x": 315,
						"y": 764,
						"w": 155,
						"h": 379
					}
				},
				{
					"filename": "18.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 14,
						"w": 155,
						"h": 377
					},
					"frame": {
						"x": 315,
						"y": 1145,
						"w": 155,
						"h": 377
					}
				},
				{
					"filename": "19.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 15,
						"w": 155,
						"h": 376
					},
					"frame": {
						"x": 315,
						"y": 1524,
						"w": 155,
						"h": 376
					}
				},
				{
					"filename": "20.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 15,
						"w": 155,
						"h": 376
					},
					"frame": {
						"x": 472,
						"y": 1,
						"w": 155,
						"h": 376
					}
				},
				{
					"filename": "46.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 15,
						"w": 155,
						"h": 376
					},
					"frame": {
						"x": 629,
						"y": 1,
						"w": 155,
						"h": 376
					}
				},
				{
					"filename": "15.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 16,
						"w": 155,
						"h": 375
					},
					"frame": {
						"x": 786,
						"y": 1,
						"w": 155,
						"h": 375
					}
				},
				{
					"filename": "40.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 16,
						"w": 155,
						"h": 375
					},
					"frame": {
						"x": 943,
						"y": 1,
						"w": 155,
						"h": 375
					}
				},
				{
					"filename": "12.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 19,
						"w": 155,
						"h": 372
					},
					"frame": {
						"x": 1100,
						"y": 1,
						"w": 155,
						"h": 372
					}
				},
				{
					"filename": "16.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 19,
						"w": 155,
						"h": 372
					},
					"frame": {
						"x": 1257,
						"y": 1,
						"w": 155,
						"h": 372
					}
				},
				{
					"filename": "45.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 19,
						"w": 155,
						"h": 372
					},
					"frame": {
						"x": 1414,
						"y": 1,
						"w": 155,
						"h": 372
					}
				},
				{
					"filename": "17.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 21,
						"w": 155,
						"h": 370
					},
					"frame": {
						"x": 1571,
						"y": 1,
						"w": 155,
						"h": 370
					}
				},
				{
					"filename": "14.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 22,
						"w": 155,
						"h": 369
					},
					"frame": {
						"x": 1728,
						"y": 1,
						"w": 155,
						"h": 369
					}
				},
				{
					"filename": "44.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 22,
						"w": 155,
						"h": 369
					},
					"frame": {
						"x": 1885,
						"y": 1,
						"w": 155,
						"h": 369
					}
				},
				{
					"filename": "43.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 24,
						"w": 155,
						"h": 367
					},
					"frame": {
						"x": 1728,
						"y": 372,
						"w": 155,
						"h": 367
					}
				},
				{
					"filename": "36.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 25,
						"w": 155,
						"h": 366
					},
					"frame": {
						"x": 1571,
						"y": 373,
						"w": 155,
						"h": 366
					}
				},
				{
					"filename": "35.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 26,
						"w": 155,
						"h": 365
					},
					"frame": {
						"x": 1885,
						"y": 372,
						"w": 155,
						"h": 365
					}
				},
				{
					"filename": "39.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 26,
						"w": 155,
						"h": 365
					},
					"frame": {
						"x": 1885,
						"y": 739,
						"w": 155,
						"h": 365
					}
				},
				{
					"filename": "42.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 29,
						"w": 155,
						"h": 362
					},
					"frame": {
						"x": 1100,
						"y": 375,
						"w": 155,
						"h": 362
					}
				},
				{
					"filename": "11.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 30,
						"w": 155,
						"h": 361
					},
					"frame": {
						"x": 786,
						"y": 378,
						"w": 155,
						"h": 361
					}
				},
				{
					"filename": "38.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 30,
						"w": 155,
						"h": 361
					},
					"frame": {
						"x": 943,
						"y": 378,
						"w": 155,
						"h": 361
					}
				},
				{
					"filename": "41.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 30,
						"w": 155,
						"h": 361
					},
					"frame": {
						"x": 472,
						"y": 379,
						"w": 155,
						"h": 361
					}
				},
				{
					"filename": "34.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 32,
						"w": 155,
						"h": 359
					},
					"frame": {
						"x": 629,
						"y": 379,
						"w": 155,
						"h": 359
					}
				},
				{
					"filename": "33.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 34,
						"w": 155,
						"h": 357
					},
					"frame": {
						"x": 629,
						"y": 740,
						"w": 155,
						"h": 357
					}
				},
				{
					"filename": "37.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 35,
						"w": 155,
						"h": 356
					},
					"frame": {
						"x": 472,
						"y": 742,
						"w": 155,
						"h": 356
					}
				},
				{
					"filename": "9.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 38,
						"w": 155,
						"h": 353
					},
					"frame": {
						"x": 1257,
						"y": 375,
						"w": 155,
						"h": 353
					}
				},
				{
					"filename": "10.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 39,
						"w": 155,
						"h": 352
					},
					"frame": {
						"x": 1414,
						"y": 375,
						"w": 155,
						"h": 352
					}
				},
				{
					"filename": "30.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 40,
						"w": 155,
						"h": 351
					},
					"frame": {
						"x": 1414,
						"y": 729,
						"w": 155,
						"h": 351
					}
				},
				{
					"filename": "32.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 42,
						"w": 155,
						"h": 349
					},
					"frame": {
						"x": 1257,
						"y": 730,
						"w": 155,
						"h": 349
					}
				},
				{
					"filename": "31.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 44,
						"w": 155,
						"h": 347
					},
					"frame": {
						"x": 1100,
						"y": 739,
						"w": 155,
						"h": 347
					}
				},
				{
					"filename": "8.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 45,
						"w": 155,
						"h": 346
					},
					"frame": {
						"x": 1257,
						"y": 1081,
						"w": 155,
						"h": 346
					}
				},
				{
					"filename": "7.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 49,
						"w": 155,
						"h": 342
					},
					"frame": {
						"x": 1571,
						"y": 741,
						"w": 155,
						"h": 342
					}
				},
				{
					"filename": "6.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 52,
						"w": 155,
						"h": 339
					},
					"frame": {
						"x": 1414,
						"y": 1082,
						"w": 155,
						"h": 339
					}
				},
				{
					"filename": "1.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 57,
						"w": 155,
						"h": 334
					},
					"frame": {
						"x": 1728,
						"y": 741,
						"w": 155,
						"h": 334
					}
				},
				{
					"filename": "5.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 59,
						"w": 155,
						"h": 332
					},
					"frame": {
						"x": 1728,
						"y": 1077,
						"w": 155,
						"h": 332
					}
				},
				{
					"filename": "4.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 60,
						"w": 155,
						"h": 331
					},
					"frame": {
						"x": 1571,
						"y": 1085,
						"w": 155,
						"h": 331
					}
				},
				{
					"filename": "3.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 63,
						"w": 155,
						"h": 328
					},
					"frame": {
						"x": 1885,
						"y": 1106,
						"w": 155,
						"h": 328
					}
				},
				{
					"filename": "2.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 66,
						"w": 155,
						"h": 325
					},
					"frame": {
						"x": 1728,
						"y": 1411,
						"w": 155,
						"h": 325
					}
				},
				{
					"filename": "0.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 155,
						"h": 391
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 71,
						"w": 155,
						"h": 320
					},
					"frame": {
						"x": 1571,
						"y": 1418,
						"w": 155,
						"h": 320
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:606642ac4a422bb2131add6fce7c6287:6d6ab10a64f8d5799e83b86322722e8f:cb6c8a6d87bb76b564d5d0b40a853b6e$"
	}
}
;